import { makeStyles } from "@material-ui/core/styles";

const useStyleMotto = makeStyles((theme) => ({
  boxmotto: {
    backgroundColor: "#91A4AD",
    height: "20vh",
    [theme.breakpoints.down('sm')]: {
      height: "25vh",
    },
    display: "flex",
    flexDirection: "column",
    // flexWrap: "wrap",
    justifyContent: "center",
    marginTop: "-75px",
  },
  motto: {
    fontFamily: "'Manuale', serif",
    // backgroundColor: "#91A4AD",
    textAlign: "center",
    fontSize: "3.5vh",
    fontWeight: "300",
    // height: "20vh",
    color: "#fff",
    // marginTop: "-75px",
    // display: "flex",
    // justifyContent: "center",
    alignItems: "center",
    lineHeight: "3.2vh",
  },
  autore: {
    color: theme.palette.primary.dark,
    fontSize: '1.2rem',
    fontStyle: 'italic',
    fontWeight: '300',
    textAlign: 'right',
    paddingRight: '20px',
    marginTop: '0.5rem',
  },
}));

export default useStyleMotto;
